import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { GroupOverviewScreen } from '@/features/group-reports/group-overview-screen'
import {
  type GroupReportSearch,
  groupReportSearchFrom,
  groupReportSearchKey,
} from '@/features/group-reports/group-report-search'
import { GROUP_REPORT_PERMISSION, getCompanyReach } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/group/reports/')({
  validateSearch: (search: Record<string, unknown>): Partial<GroupReportSearch> =>
    groupReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    // Group routes inspect cached /me only. A short reach is rendered as an
    // access state by the screen, rather than redirected, and no report query
    // is enabled for it.
    getCompanyReach(context.queryClient, GROUP_REPORT_PERMISSION)
  },
  component: GroupReportsIndexRoute,
})

function GroupReportsIndexRoute() {
  const navigate = useNavigate()
  const routeSearch = Route.useSearch()
  const search: GroupReportSearch = {
    selection: routeSearch.selection ?? { kind: 'all' },
    from: routeSearch.from,
    as_at: routeSearch.as_at,
    prior: routeSearch.prior ?? '0',
    sort: routeSearch.sort ?? 'net_result_desc',
  }

  return (
    <GroupOverviewScreen
      key={groupReportSearchKey(search)}
      {...{
        search,
        onSearchChange: (next: GroupReportSearch) =>
          void navigate({ to: '/group/reports', search: next }),
      }}
    />
  )
}
